function mockNanoid() {
  return Math.random().toString(36).substr(2, 6);
}

module.exports = {
  default: mockNanoid,
  nanoid: mockNanoid,
};
